import vars from '../vars';

class Actor {
  constructor(parent) {
    this.parent = parent;
    this.sprite = null;
  }

  setPerspective(hasFloor = false) {
    const perspective = -0.8;
    const escapePoint = { x: 0, y: -vars.layout.STAGE_HEIGHT / 2.5 };
    const pos = this.sprite.toLocal(
      escapePoint,
      undefined, undefined, undefined,
      global.PIXI.projection.TRANSFORM_STEP.BEFORE_PROJ,
    );
    pos.y = -pos.y;
    pos.x = -pos.x;
    this.sprite.proj.setAxisY(pos, perspective);
    if (hasFloor) {
      this.floor.tileProj.setAxisY(pos, perspective);
    }
  }
}

export default Actor;
